<template>
  <b-modal
    :active="displayModal"
    has-modal-card
    @close="$emit('close')"
    :can-cancel="['escape', 'x', 'outside']"
  >
    <div class="dialog" style="width: 800px; height: auto">
      <div class="modal-card" style="max-width: 100%">
        <form @submit.prevent="validateBeforeSubmit">
          <header class="modal-card-head">
            <p class="modal-card-title">
              {{ $t('compSuperadminUserModal.title-1') }}
            </p>
          </header>
          <section class="modal-card-body">
            <serveur-info :erreur="$t(error)" />
            <b-field
              :label="$t('compSuperadminUserModal.label-1') + ' *'"
              :type="{ 'is-danger': errors.has('email') }"
              :message="errors.first('email')"
            >
              <b-input
                v-model="citem.email"
                name="email"
                required="required"
                v-validate="{
                  required: true,
                  email: true
                }"
                :placeholder="$t('compSuperadminUserModal.label-1') + ' *'"
                data-testid="input-email"
              >
              </b-input>
            </b-field>
            <br />
          </section>
          <footer class="modal-card-foot">
            <b-button class="button" icon-left="close" @click="$emit('close')">
              {{ $t('cancel') }}
            </b-button>
            <button
              type="submit"
              class="button is-primary"
              data-testid="submit-update-user"
            >
              <b-icon size="is-small" icon="refresh" />
              <span> {{ $t('update') }} </span>
            </button>
          </footer>
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { User } from '@/models/user/user.js'

export default {
  name: 'UserModal',
  inject: ['$validator'],
  components: {
    'serveur-info': () => import('@/components/ServeurInfo.vue')
  },
  props: {
    displayModal: {
      type: Boolean,
      default: false
    },
    item: {
      type: User,
      default: function () {
        return new User()
      }
    },
    error: {
      type: String,
      default: function () {
        return ''
      }
    }
  },
  data () {
    return {
      citem: this.item.clone()
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('update', {
            email: this.item.email,
            item: this.citem
          })
        }
      })
    }
  },
  watch: {
    item: {
      handler () {
        this.citem = this.item.clone()
      },
      deep: true
    }
  }
}
</script>
